import { useField } from 'formik';
import find from 'lodash/find.js';
import React from 'react';
import { Props } from './SelectSortBy.js';
import { SelectSortBy } from './SelectSortBy.js';

interface FormProps {
  name: string;
}

export const FormSelectSortBy: React.FC<
  FormProps & Omit<Props, 'value' | 'onChange'>
> = ({ name, options, ...props }) => {
  const [field, , helpers] = useField(name);
  return (
    <SelectSortBy
      {...props}
      value={find(options, ['value', field.value]) || null}
      onChange={({ value }) => {
        helpers.setValue(value);
      }}
      options={options}
    />
  );
};
